import React from "react";
import { Select, Button, Space } from "antd";
import { $t } from "~/i18n.js";
import { EyeInvisibleFilled } from "@ant-design/icons";

/**
 * PayingMemberSelector component for selecting a paying member (betalend lid).
 *
 * Props:
 * - value: current selected value (user id)
 * - onChange: function to call when selection changes
 * - vliegers: array of user objects { id, name }
 * - flight: flight object (for future detailed options)
 * - disabled: (optional) disables the select
 */
export function PayingMemberSelector({
  value,
  onChange,
  vliegers,
  flight,
  disabled,
  onlyToggle,
}) {
  const gezagvoerderId =
    flight && flight.gezagvoerder_id > 0 && flight.gezagvoerder_id;
  const tweedeInzittendeId =
    flight && flight.tweede_inzittende_id > 0 && flight.tweede_inzittende_id;
  const isAfgeschermd = flight && flight.betalend_lid_id === -99;
  const buttonsDisabled = disabled || isAfgeschermd;
  const isDeleted =
    flight &&
    (flight.betalend_lid_id === "DELETE" || flight.betalend_lid_id < 0);

  return (
    <div>
      <Space style={{ marginBottom: 8 }}>
        <Button
          type={value === gezagvoerderId ? "primary" : "default"}
          onClick={() => gezagvoerderId && onChange(gezagvoerderId)}
          disabled={buttonsDisabled || !gezagvoerderId}
          size="small"
        >
          {$t("Gezagvoerder")}
        </Button>
        <Button
          type={value === tweedeInzittendeId ? "primary" : "default"}
          onClick={() => tweedeInzittendeId && onChange(tweedeInzittendeId)}
          disabled={buttonsDisabled || !tweedeInzittendeId}
          size="small"
        >
          {$t("Tweede inzittende")}
        </Button>
      </Space>

      {onlyToggle ? null : isAfgeschermd ? (
        <p>
          <EyeInvisibleFilled /> {$t("Afgeschermd")}
        </p>
      ) : (
        <Select
          value={isDeleted ? undefined : value}
          onChange={onChange}
          disabled={disabled}
          showSearch
          style={{ width: "100%", minWidth: 200 }}
          filterOption={(input, option) => {
            // AntD v4: option.children, v5: option.label
            const label = option?.label || option?.children;
            if (typeof label === "string") {
              return label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
            }
            return false;
          }}
          placeholder={$t("Selecteer betalend lid")}
        >
          {vliegers &&
            vliegers.map(
              (user, key) =>
                user.id > 0 && (
                  <Select.Option key={key} value={user.id} label={user.name}>
                    {user.name}
                  </Select.Option>
                ),
            )}
        </Select>
      )}
    </div>
  );
}
